import React, { useEffect } from 'react';
import { useFormContext, useController } from 'react-hook-form';
import { TextField } from 'edenred-ui';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { createRules, FormFields } from '@epi-forms/helpers';
import { workingDaysLimit, number } from '@epi-helpers/formHelpers/validators';
import { getMaxWorkingDays } from '@epi-selectors/settings';

export const WorkingDaysField = () => {
  const { control, trigger, watch, resetField } = useFormContext();
  const { t } = useTranslation();
  const maxWorkingDays = useSelector(getMaxWorkingDays);
  const rules = createRules([workingDaysLimit(maxWorkingDays), number]);
  const name = FormFields.DaysForLunari;
  const employmentType = watch(FormFields.EmployeeType);

  const {
    field: { onChange, value },
    fieldState: { error }
  } = useController({
    name,
    control,
    rules,
    defaultValue: maxWorkingDays ?? ''
  });

  const onChangeValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const formattedValue =
      !event.target.value || isNaN(+event.target.value)
        ? event.target.value
        : +event.target.value;

    onChange(formattedValue);
  };

  useEffect(() => {
    resetField(name, { defaultValue: maxWorkingDays });
  }, [maxWorkingDays]);

  useEffect(() => {
    trigger(name);
  }, [employmentType]);

  useEffect(() => {
    return () => resetField(name);
  }, []);

  return (
    <TextField
      id={name}
      label={t('containers.deposit_money.topup_tab.form.days.title')}
      value={value ?? ''}
      onChange={onChangeValue}
      readOnly={false}
      error={!!error}
      helperText={error?.message}
    />
  );
};
